import { BaseEntity } from "yt-ng-framework";

export class TipDokumentaSef extends BaseEntity{
    constructor(){
        super();
    };

    GenericName: string = null;
    PravacDokumentaId: number = null;
    Naziv: string = null;

    Deserialize(input: this) {
        this.ID = input.ID;
        this.GenericName = input.GenericName;
        this.Naziv = input.Naziv;
        this.PravacDokumentaId = input.PravacDokumentaId;
        return this;
    }

    Serialize(input: TipDokumentaSef){
        return input;
    }
}